import { render, staticRenderFns } from "./CoursewareAdminTemplates.vue?vue&type=template&id=f5b0b6cc&"
import script from "./CoursewareAdminTemplates.vue?vue&type=script&lang=js&"
export * from "./CoursewareAdminTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports